import { render, staticRenderFns } from "./create-coupon.vue?vue&type=template&id=19212f22&scoped=true&"
import script from "./create-coupon.vue?vue&type=script&lang=js&"
export * from "./create-coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19212f22",
  null
  
)

export default component.exports